import { React } from 'react';
import Tab from './tabs';

function AdminCIERHA() {
  return (
    <div className="admin-page">
      <body>
        <Tab />
      </body>
    </div>
  );
}

export default AdminCIERHA;
